import React, { useCallback } from "react";
import { StoreAllFilesComponent } from "./AllFilesComponent";
import { onPressIntegrationFileType } from "./FilesScreenComponent";
import { useOpenFile } from "./useOpenFile";
import { FileNavigatorScreenProp } from "./FileStack";

type Props = FileNavigatorScreenProp<"AllFiles">;

export function AllFilesScreen(props: Props) {
  const openFile = useOpenFile();
  const onPressIntegrationFile: onPressIntegrationFileType = useCallback(
    ({ id, title }) => {
      props.navigation.navigateDeprecated("EmaginWebview", {
        eMaginId: id,
        title,
      });
    },
    [props.navigation]
  );
  return (
    <StoreAllFilesComponent
      onPressFile={openFile}
      onPressIntegrationFile={onPressIntegrationFile}
      includeIntegrationFiles
    />
  );
}
